import './Payment.css'
import React from 'react';
import { useLocation } from 'react-router';
import Header from '../components/Header';
import Button from '../components/Button';
import SelectionButton from '../components/SelectionButton';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

function Payment() {

    const [paymentType, setPaymentType] = useState('');
    const [orderName, setOrderName] = useState('');
    const [cashGiven, setCashGiven] = useState('');
    const [changeDue, setChangeDue] = useState(0);
    const [sendPaymentError, setSendPaymentError] = useState(0);

    let location = useLocation();
    const navigate = useNavigate();
    const total = location.state.total;
    const order = location.state.order;
    const orderType = location.state.orderType;
    const currentItemNum = location.state.currentItemNum;

    async function sendOrder() {
        let fullOrder = {};
        fullOrder.items = order;
        fullOrder.name = orderName;
        fullOrder.totalPrice = total;
        fullOrder.orderType = orderType;
        fullOrder.paymentType = paymentType;
        fullOrder.status = 'todo';

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/orders/`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(fullOrder),
              withCredentials: true,
              credentials: 'include',
            });
            if (!response.ok) {
                setSendPaymentError(response.status);
              throw new Error('Network response was not ok');
            }
          
            const jsonResponse = await response.json();
            console.log('POST request successful:', jsonResponse);
            navigate('/takeorder', {state: {orderType: orderType}})
        } catch (error) {
            setSendPaymentError(500);
            console.error('POST request failed:', error);
        }
    }

    return(
        <div className='main-payment-page'>
            <Header />
            <div className='payments-section'>
                <div className='order-total-div'>
                    <h3>Order total: ${total.toFixed(2)}</h3>
                </div>

                {
                    orderType === 'drivethru' ? <div className='order-name-div'>
                        <h3>Who is this order for?</h3>
                        <input className='order-name-input' value={orderName} onChange={(e) => setOrderName(e.target.value)} />
                    </div> : null
                }
                
                {
                    paymentType === '' ? <div className='payment-type-div'>

                        <h3>How will the payment be made?</h3>
                        <div className='payment-type-buttons'>
                            <SelectionButton buttonText='Cash' onClickFunction={() => setPaymentType('cash')}/>
                            <SelectionButton buttonText='Credit/Debit Card' onClickFunction={() => setPaymentType('card')}/>
                        </div>
                </div> : null
                } 
                {
                    paymentType === 'cash' ? <div className='cash-div'>
                        <div className='amount-paid-div'>
                            <h3>Cash Amount Received:</h3>
                            <div className='input-field-div'>
                                <span className='dollar-span'>$</span><input className='actual-paid-input' type="number" min="0.00" max="10000.00" step="0.01" value={cashGiven} onChange={(e) => setCashGiven(e.target.value)}/>
                                <Button className='actual-paid-button' buttonText='Enter' onClickFunction={() => setChangeDue(cashGiven - total)}/>
                            </div>
                        </div>
                        <div className='change-needed-div'>
                            <h2>Change needed: ${changeDue.toFixed(2)}</h2>
                        </div>
                    </div> : null
                }
                <div className='payment-buttons'>
                    <Link to='/takeorder' state={{ total: total, order: order, orderType: orderType, currentItemNum: currentItemNum}}>
                        <Button className='go-back-button' buttonText='Back To Order' />
                    </Link>
                    {
                        ((orderType === 'dinein' || orderType === 'takeout') || orderName !== '') && paymentType !== '' ?
                            <Button className='send-order-button' onClickFunction={sendOrder} buttonText='Complete Payment'/> : null
                    }

                </div>
                {
                        sendPaymentError !== 0 ? <h4 style={{color: 'red'}}>Error sending payment</h4> : null
                }
            </div>
            
        </div>
    )
}

export default Payment;